import { createStructuredSelector } from 'reselect';
import { legendVisibilitySelector } from '@selectors/uiSelector';

export const structuredSelector = createStructuredSelector({
  show: legendVisibilitySelector,
});

export type StructuredSelectorProps = {
  show: boolean;
};
